//@flow
import { connect } from 'react-redux';
import NewPaymentMeanPage from '../../components/payments/NewPaymentMeanPage';
import { changePaymentMeanOnDashboard } from '../../modules/Payment/actions';

const mapStateToProps = state => ({
  noMargin: true,
  cardRegistrationIssuePage: 'cardRegistrationIssue',
});

const mapDispatchToProps = {
  addPaymentMean: changePaymentMeanOnDashboard,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPaymentMeanPage);
